var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /home/ec2-user/Source/aws-lex-web-ui/node_modules/core-js/library/modules/_html.js
// module id = 160
// module chunks = 0